import React from "react";
import STRATEGIC_PARTNER from "../../../constants/strategicPartners";

const email = STRATEGIC_PARTNER.CONTACT_SUPPORT.EMAIL;

const SupportEmailLink = ({textOverride}) => (
    <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">{textOverride || email}</a>
);

export default SupportEmailLink;
